import { CaseState } from 'app/area/case/types-store';
import { sequence, maxSequenceEntity } from 'app/area/case/features/connected-cases/sequence';
import { StoreData } from 'app/types-shared';
import { getCaseData } from 'app/infrastructure/ui/renderer/resolvers';
import { tableName } from 'app/area/case/case-data-model';
import { getChildEntities } from 'app/infrastructure/store/query';

export const connectedCasesMaxSequence = 
  (state: CaseState, uiEngineProps: any) => {
    const caseData: StoreData = getCaseData(state, uiEngineProps);
    const hostProps = uiEngineProps.hostProps();
    const connectionTypeId = uiEngineProps.componentDescriptor.properties.connectionTypeId;
    const pathToConnectionType = [{[tableName.trans]: hostProps.entityId}, {[tableName.connectionTypes]: connectionTypeId}];
    const connections = getChildEntities(caseData, pathToConnectionType, tableName.connectedCases);
    
    const maxSeq = maxSequenceEntity(connections);

    return {
      maxSequence: sequence(maxSeq)
    };
  };
